import { makeStyles } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(theme => ({
  accordeonDetails: {
    padding: '13px 39px 23px',
  },
  title: {
    color: '#393939',
    fontWeight: 600,
  },
  text: {
    fontSize: 20,
    lineHeight: 1.7,
    margin: 0,
    textAlign: ({ direction }: LayoutDirection) => direction === 'rtl' ? 'right': 'unset'
  },
  link: {
    color: '#393939',
  },
  list: {
    padding: 0,
  },
  subList: {
    padding: ({ direction }: LayoutDirection) => direction === 'rtl' ? theme.spacing(0, 15, 0, 0) : theme.spacing(0, 0, 0, 15),
  },
  listItem: {
    display: 'block',
    padding: 0,
  },
}));
